import http from '@/http'
const URL = '/admin/guests'

export const list = async (params) => {
  const list = (await http.get(URL, { params: params }))
  return list
}

export const show = async (id) => {
  let one = null
  if (id) {
    one = (await http.get(URL + `/${id}?include=tags,group`))
  }
  return one
}

export const saveGuest = (payload) => {
  if (payload.id) {
    return http.put(URL + `/${payload.id}`, payload)
  }
  return http.post(URL, payload)
}

export const importUsers = (payload) => {
  return http.post(URL + '/import', payload, { headers: { 'Content-Type': 'multipart/form-data' } })
}

// Baixa o modelo de planilha de importação (gerado a partir do formulário do grupo).
// layout: 'inline' (lado a lado) | 'stacked' (empilhado)
export const downloadTemplate = async ({ groupId = null, formId = null, layout = 'inline' } = {}) => {
  const params = { layout }
  if (groupId) params.group_id = groupId
  if (formId) params.form_id = formId
  return http.get(URL + '/import-template', { params, responseType: 'blob' })
}

// Legenda das colunas do modelo (para a tabela do modal de importação).
export const importColumns = async ({ groupId = null, formId = null } = {}) => {
  const params = {}
  if (groupId) params.group_id = groupId
  if (formId) params.form_id = formId
  return http.get(URL + '/import-columns', { params })
}

// Lista de formulários ativos (para o seletor do modal de importação).
export const importForms = async () => http.get(URL + '/import-forms')

export const delGuest = async (id) => http.delete(URL + `/${id}`)
export const changeStatus = (payload) => http.put(URL + `/${payload.id}/status`, payload)

export default {
  list,
  show,
  saveGuest,
  importUsers,
  downloadTemplate,
  importColumns,
  importForms,
  delGuest,
  changeStatus
}
